/* ==========================================================================
   cart-drawer-v2.js
   Only responsibility: AJAX add-to-cart for the cross-sell ("Frequently bought
   together") cards. It reuses Dawn's own <cart-drawer>.renderContents(), which
   re-renders the whole #CartDrawer (items + progress bar + breakdown + footer)
   and the cart-icon-bubble from server HTML, then re-opens the drawer — so the
   new UI stays perfectly in sync and the drawer never closes.

   Quantity +/- , quantity input, and remove all keep using Dawn's existing
   <quantity-input> / cart.js handlers — we add nothing there.
   Checkout stays a native form submit (name="checkout") so GoKwik is untouched.
   ========================================================================== */
(function () {
  'use strict';

  function addUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/cart/add.js';
  }

  function sectionsToRequest(drawer) {
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function addCrossSell(variantId, btn) {
    var drawer = document.querySelector('cart-drawer');
    if (!variantId || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sectionsToRequest(drawer),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.status) {
          // Shopify add error (e.g., sold out) — surface in the cart error region if present.
          var errEl = document.getElementById('CartDrawer-CartErrors');
          if (errEl) errEl.textContent = data.description || data.message || '';
          return;
        }
        if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
          drawer.renderContents(data); // re-renders #CartDrawer + icon, then opens
          syncFreeGift(); // the added item may be a free-gift trigger
        } else {
          // Fallback: hard navigate so the cart is never left in a stale state.
          window.location = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root.replace(/\/$/, '')
            : '') + '/cart';
        }
      })
      .catch(function (e) { console.error('[cart-drawer-v2] add failed', e); })
      .finally(function () { btn.classList.remove('is-loading'); });
  }

  // Delegated click — survives drawer re-renders (innerHTML swaps).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cdv2-add]');
    if (!btn) return;
    e.preventDefault();
    addCrossSell(btn.getAttribute('data-variant-id'), btn);
  });

  // Remove a line (and, if it's the gift trigger, the gift too) in ONE /cart/update
  // request — no second call, so there's no race/error. Raw fetch doesn't publish
  // cart-update, so the reconcile subscriber won't fire a competing change.
  function combinedRemove(variantId) {
    if (giftSyncing || !variantId) return;
    var updates = {};
    updates[variantId] = 0;
    if (FREE_GIFT.triggerVariantIds.indexOf(variantId) !== -1) {
      updates[FREE_GIFT.giftVariantId] = 0; // pull the free gift out with its trigger
      giftPresent = false;
    }
    var drawer = document.querySelector('cart-drawer');
    giftSyncing = true;
    fetch(cartRoot() + '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: sectionsToRequest(drawer), sections_url: window.location.pathname }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) drawer.renderContents(data);
      })
      .catch(function (err) { console.error('[free-gift] combined remove failed', err); })
      .finally(function () { giftSyncing = false; });
  }

  function variantIdOfItem(itemEl) {
    var input = itemEl && itemEl.querySelector('.cdv2-qty__input');
    return input ? Number(input.getAttribute('data-quantity-variant-id')) : 0;
  }

  // Stepper "−" at quantity 1: remove the line (a "0" change errors on quantity-ruled
  // products). Capture phase so it beats Dawn's own stepper handler.
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('.cdv2-qty__btn--minus');
    if (!minus) return;
    var qtyInput = minus.parentElement && minus.parentElement.querySelector('.cdv2-qty__input');
    if (!qtyInput) return;
    if ((parseInt(qtyInput.value, 10) || 0) > 1) return; // normal decrement → let Dawn handle it
    e.preventDefault();
    e.stopImmediatePropagation();
    combinedRemove(variantIdOfItem(minus.closest('.cdv2-item')));
  }, true);

  // REMOVE on a trigger line: intercept so the gift leaves in the same request (no race).
  // Non-trigger REMOVE is left to Dawn (its removal doesn't affect the gift).
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('.cdv2-item__removebtn');
    if (!rm) return;
    var vid = variantIdOfItem(rm.closest('.cdv2-item'));
    if (FREE_GIFT.triggerVariantIds.indexOf(vid) === -1) return; // not the trigger → Dawn handles it
    e.preventDefault();
    e.stopImmediatePropagation();
    combinedRemove(vid);
  }, true);

  // ==========================================================================
  // Free gift: auto-add the PDRN Pink Collagen Mask when the 4-in-1 Skincare
  // Wand is in the cart. The gift line carries a `_free_gift` property so it can
  // be recognised + locked in the template. Its ₹0 price comes from a Shopify
  // automatic "Buy X Get Y" discount — this JS only manages presence/quantity.
  // ==========================================================================
  var FREE_GIFT = {
    triggerVariantIds: [51371109908612], // 4-in-1 Skincare Wand
    giftVariantId: 52533746499716,       // Noor PDRN Pink Collagen Gel Mask (Free Gift) — dedicated ₹0 variant
    property: '_free_gift',
  };
  // Expose so the GoKwik "Buy It Now" (direct checkout, bypasses the cart) can
  // include the same free gift — single source of truth for the IDs.
  window.NOOR_FREE_GIFT = FREE_GIFT;
  var giftSyncing = false;
  var giftPresent = null; // cached: is the gift line currently in the cart? (null = unknown)

  function cartRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '');
  }
  function isTrigger(it) { return FREE_GIFT.triggerVariantIds.indexOf(it.variant_id) !== -1; }
  function isGiftLine(it) {
    return it.variant_id === FREE_GIFT.giftVariantId && it.properties && it.properties[FREE_GIFT.property];
  }

  // Perform a single cart op (add/change), re-render the drawer, release the lock.
  function runGiftOp(op) {
    var drawer = document.querySelector('cart-drawer');
    op.payload.sections = sectionsToRequest(drawer);
    op.payload.sections_url = window.location.pathname;
    return fetch(cartRoot() + op.url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(op.payload),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
          drawer.renderContents(data);
        }
      })
      .finally(function () { giftSyncing = false; });
  }

  function addGiftPayload() {
    var props = {}; props[FREE_GIFT.property] = 'true';
    return { url: '/cart/add.js', payload: { items: [{ id: FREE_GIFT.giftVariantId, quantity: 1, properties: props }] } };
  }

  // Reconcile the gift line against a known set of cart items (no network read needed).
  function reconcile(items) {
    var hasTrigger = items.some(isTrigger);
    // Any line flagged as an auto free-gift (by property). Legacy gifts (wrong variant) are stale.
    var giftLines = items.filter(function (it) { return it.properties && it.properties[FREE_GIFT.property]; });
    var currentGift = giftLines.filter(function (it) { return it.variant_id === FREE_GIFT.giftVariantId; })[0];
    var staleGift = giftLines.filter(function (it) { return it.variant_id !== FREE_GIFT.giftVariantId; })[0];
    giftPresent = !!currentGift;

    // 1) Drop any stale/legacy gift line (e.g. the old ₹599 variant) first.
    if (staleGift) { return runGiftOp({ url: '/cart/change.js', payload: { id: staleGift.key, quantity: 0 } }); }
    // 2) Add the ₹0 gift when the trigger is present and it's missing.
    if (hasTrigger && !currentGift) { giftPresent = true; return runGiftOp(addGiftPayload()); }
    // 3) Remove the gift when the trigger is gone.
    if (!hasTrigger && currentGift) { giftPresent = false; return runGiftOp({ url: '/cart/change.js', payload: { id: currentGift.key, quantity: 0 } }); }
    // 4) Keep the gift at exactly one.
    if (currentGift && currentGift.quantity !== 1) { return runGiftOp({ url: '/cart/change.js', payload: { id: currentGift.key, quantity: 1 } }); }
    giftSyncing = false; // already correct — nothing to do
  }

  // Full sync. Uses a cart object if we already have one (from the event); else reads /cart.js.
  function syncFreeGift(knownCart) {
    if (giftSyncing) return;
    giftSyncing = true;
    if (knownCart && knownCart.items) { reconcile(knownCart.items); return; }
    fetch(cartRoot() + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { reconcile((cart && cart.items) || []); })
      .catch(function (e) { console.error('[free-gift] sync failed', e); giftSyncing = false; });
  }

  // Instantly show a placeholder gift line so there is no visible "pop-in" while the
  // real add request is in flight. The next renderContents() replaces the whole drawer,
  // so the placeholder is discarded automatically.
  function injectGiftPlaceholder() {
    var list = document.querySelector('#CartDrawer-CartItems') || document.querySelector('.cdv2-items');
    if (!list) return;
    if (list.querySelector('.cdv2-item__giftnote') || list.querySelector('.cdv2-gift-placeholder')) return;
    var img = 'https://cdn.shopify.com/s/files/1/0977/8420/1348/files/NoorPDRNMASKImageCarousel.jpg?width=200';
    list.insertAdjacentHTML('afterbegin',
      '<div class="cart-item cdv2-item cdv2-gift-placeholder" role="row">' +
        '<div class="cdv2-item__media"><img class="cdv2-item__img" src="' + img + '" alt="Noor PDRN Pink Collagen Gel Mask" width="68" height="68"></div>' +
        '<div class="cdv2-item__body">' +
          '<div class="cdv2-item__top">' +
            '<a class="cdv2-item__title">🎁 Noor PDRN Pink Collagen Gel Mask (Free Gift)</a>' +
            '<span class="cdv2-item__linetotal is-free">Free</span>' +
          '</div>' +
          '<p class="cdv2-item__unit is-free">Free</p>' +
          '<p class="cdv2-item__giftnote">Free gift — added automatically 🎉</p>' +
        '</div>' +
      '</div>');
  }

  // Fast path for a product-form add: we know which variant was added, so if it's the
  // trigger and the gift is absent, show it instantly + add it in ONE hop (no /cart.js read).
  function onProductAdded(addedVariantId) {
    if (FREE_GIFT.triggerVariantIds.indexOf(addedVariantId) === -1) return;
    if (giftPresent === true) return;               // gift already there → nothing to do (no lag)
    injectGiftPlaceholder();                        // instant visual feedback
    if (giftSyncing) return;
    if (giftPresent === false) {                    // known absent → add immediately
      giftSyncing = true;
      giftPresent = true;
      runGiftOp(addGiftPayload());
      return;
    }
    syncFreeGift();                                 // unknown → safe fetch path
  }

  // Re-sync on every cart change. cart.js-sourced events carry the full cart (no read
  // needed); product-form adds carry just the added variant (fast path).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (e && e.cartData && e.cartData.items) { syncFreeGift(e.cartData); }
      else if (e && e.source === 'product-form' && e.productVariantId) { onProductAdded(Number(e.productVariantId)); }
      else { syncFreeGift(); }
    });
  }
  // Initial pass (covers a cart that already holds the trigger on page load).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncFreeGift(); });
  } else {
    syncFreeGift();
  }

  // The instant the drawer renders the trigger (Wand) line, show the gift placeholder —
  // this kills the pop-in lag regardless of when the network add finishes. The Wand line
  // is detected by its quantity input's data-quantity-variant-id (the gift line has none).
  (function watchDrawer() {
    var root = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
    if (!root) { document.addEventListener('DOMContentLoaded', watchDrawer); return; }
    var triggerSel = FREE_GIFT.triggerVariantIds
      .map(function (id) { return '[data-quantity-variant-id="' + id + '"]'; })
      .join(',');
    if (!triggerSel) return;
    var obs = new MutationObserver(function () {
      if (root.querySelector(triggerSel)) injectGiftPlaceholder(); // guarded: no-op if gift/placeholder already shown
    });
    obs.observe(root, { childList: true, subtree: true });
  })();

  // Announcement carousel — rotate messages. Re-queries the bar each tick so it
  // keeps working after renderContents() rebuilds the drawer. Idempotent: guard
  // against double-init if the script is evaluated more than once.
  if (!window.__cdv2AnnounceTimer) {
    window.__cdv2AnnounceTimer = setInterval(function () {
      var bar = document.querySelector('[data-cdv2-announce]');
      if (!bar) return;
      var slides = bar.querySelectorAll('.cdv2-announce__slide');
      if (slides.length < 2) return;
      var current = 0;
      for (var k = 0; k < slides.length; k++) {
        if (slides[k].classList.contains('is-active')) { current = k; break; }
      }
      slides[current].classList.remove('is-active');
      slides[(current + 1) % slides.length].classList.add('is-active');
    }, 3500);
  }
})();
